import React, { useState, useEffect } from "react";
// material
import { Card, CircularProgress, Typography } from "@mui/material";
import {
  Stack,
  Container,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip
} from "@mui/material";
import Grid from "@mui/material/Grid";
import Page from "../components/Page";

import { getSetting, getContentHistory } from "src/api/updateSetting";
import { notification } from "src/utils/messages";
import { CKEditor } from "ckeditor4-react";
import { UpdateDescriptionSetting } from "src/api/commonapi";
import { publishLeavePolicy } from "src/api/leaveSettings";

const DescriptionEdit = () => {
  const [getdata, setgetdata] = useState({
    privacy_policy_content: "",
    terms_condition_content: "",
    obt_content: "",
    obt_hindi_content: "",
    leave_policy_content: ""
  });

  const [isLoaded, setIsLoaded] = useState(false);

  const [loading, setLoading] = useState({
    privacy: false,
    terms: false,
    obt: false,
    obtHindi: false,
    leave: false
  });

  const [confirmDialog, setConfirmDialog] = useState({ open: false, key: "" });

  const [historyModal, setHistoryModal] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);

  const fieldMap = {
    privacy: "privacy_policy_content",
    terms: "terms_condition_content",
    obt: "obt_content",
    obtHindi: "obt_hindi_content",
    leave: "leave_policy_content"
  };

  const typeMap = {
    privacy: 0,
    terms: 1,
    obt: 2,
    obtHindi: 3,
    leave: 4
  };

  const saveField = async (key, m_force_accept) => {
    const fieldName = fieldMap[key];
    const settingData = { s_id: 1, type: typeMap[key], [fieldName]: getdata[fieldName] };
    if (m_force_accept !== undefined) settingData.m_force_accept = m_force_accept;
    setLoading((prev) => ({ ...prev, [key]: true }));
    const resp = await UpdateDescriptionSetting(JSON.stringify(settingData));
    setLoading((prev) => ({ ...prev, [key]: false }));
    notification({ type: resp.status == 0 ? "error" : "success", message: resp.message })();
    if (key === "leave" && (m_force_accept === 0 || m_force_accept === 1)) {
      try {
        const pres = await publishLeavePolicy({ content_html: getdata[fieldName] });
        notification({ type: pres?.status === 1 ? "success" : "error", message: pres?.message || "Published" })();
      } catch (e) {}
    }
  };

  const handleForceAccept = (m_force_accept) => {
    const key = confirmDialog.key;
    setConfirmDialog({ open: false, key: "" });
    saveField(key, m_force_accept);
  };

  const labelMap = { privacy: "Privacy Policy", terms: "Terms & Condition", leave: "Leave Policy" };

  async function fetchchapterlist() {
    try {
      const resp = await getSetting();
      if (resp.status == 1) {
        setgetdata(resp.data);
        setIsLoaded(true);
      }
    } catch {}
  }

  useEffect(() => {
    fetchchapterlist();
    fetchContentHistory();
  }, []);

  useEffect(() => {
    if (historyModal) fetchContentHistory();
  }, [historyModal]);

  async function fetchContentHistory() {
    try {
      setHistoryLoading(true);
      const resp = await getContentHistory(0);
      setHistoryLoading(false);
      if (resp.status == 1) setHistoryData(resp.data);
    } catch {
      setHistoryLoading(false);
    }
  }

  const toggleHistoryModal = () => setHistoryModal(!historyModal);

  const lastUpdateMap = {};
  historyData.forEach((item) => {
    if (!lastUpdateMap[item.column_name]) lastUpdateMap[item.column_name] = item;
  });

  return (
    <Page title="Description Edit | Local Vocal Business Group">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h4" gutterBottom>
            Description Edit
          </Typography>
          <Button onClick={toggleHistoryModal} variant="contained" startIcon={historyLoading && <CircularProgress size={18} color="inherit" />}>
            History
          </Button>
        </Stack>
        <Card style={{ marginBottom: "25px", padding: "25px" }}>
          <Stack spacing={10} style={{ marginBottom: "15px" }}>
            {isLoaded ? (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Stack spacing={0} style={{ marginBottom: "15px" }}>
                    <h3>Privacy Policy</h3>
                    <CKEditor
                      initData={getdata?.privacy_policy_content || ""}
                      config={{
                        allowedContent: true,
                        extraPlugins: "colorbutton,font",
                        removeButtons: "",
                        colorButton_colors:
                          "000000,993300,333300,003300,003366,000080,333399,333333," +
                          "800000,FF6600,808000,008000,008080,0000FF,666699,808080," +
                          "FF0000,FF9900,99CC00,339966,33CCCC,3366FF,800080,969696," +
                          "FF00FF,FFCC00,FFFF00,00FF00,00FFFF,00CCFF,993366,C0C0C0," +
                          "FF99CC,FFCC99,FFFF99,CCFFCC,CCFFFF,99CCFF,CC99FF,FFFFFF," +
                          "123456,FFA500,4CAF50,9C27B0,2196F3,034766"
                      }}
                      onChange={(event) => {
                        const data = event.editor.getData();
                        setgetdata((prevData) => ({
                          ...prevData,
                          privacy_policy_content: data
                        }));
                      }}
                    />
                    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mt: 1 }}>
                      <Typography variant="caption" color="text.secondary">
                        {lastUpdateMap["Privacy Policy"]
                          ? `Last updated by ${lastUpdateMap["Privacy Policy"].name} on ${lastUpdateMap["Privacy Policy"].date_time}`
                          : ""}
                      </Typography>
                      <Button
                        onClick={() => setConfirmDialog({ open: true, key: "privacy" })}
                        variant="contained"
                        size="small"
                        disabled={loading.privacy}
                        startIcon={loading.privacy && <CircularProgress size={16} color="inherit" />}
                      >
                        Update Privacy Policy
                      </Button>
                    </Stack>
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Stack spacing={0} style={{ marginBottom: "15px" }}>
                    <h3>Terms & Condition</h3>
                    <CKEditor
                      initData={getdata?.terms_condition_content}
                      config={{
                        allowedContent: true,
                        extraPlugins: "colorbutton,font",
                        removeButtons: "",
                        colorButton_colors:
                          "000000,993300,333300,003300,003366,000080,333399,333333," +
                          "800000,FF6600,808000,008000,008080,0000FF,666699,808080," +
                          "FF0000,FF9900,99CC00,339966,33CCCC,3366FF,800080,969696," +
                          "FF00FF,FFCC00,FFFF00,00FF00,00FFFF,00CCFF,993366,C0C0C0," +
                          "FF99CC,FFCC99,FFFF99,CCFFCC,CCFFFF,99CCFF,CC99FF,FFFFFF," +
                          "123456,FFA500,4CAF50,9C27B0,2196F3,034766"
                      }}
                      onChange={(event) => {
                        const data = event.editor.getData();
                        setgetdata((prevData) => ({
                          ...prevData,
                          terms_condition_content: data
                        }));
                      }}
                    />
                    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mt: 1 }}>
                      <Typography variant="caption" color="text.secondary">
                        {lastUpdateMap["Terms & Condition"]
                          ? `Last updated by ${lastUpdateMap["Terms & Condition"].name} on ${lastUpdateMap["Terms & Condition"].date_time}`
                          : ""}
                      </Typography>
                      <Button
                        onClick={() => setConfirmDialog({ open: true, key: "terms" })}
                        variant="contained"
                        size="small"
                        disabled={loading.terms}
                        startIcon={loading.terms && <CircularProgress size={16} color="inherit" />}
                      >
                        Update Terms & Condition
                      </Button>
                    </Stack>
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Stack spacing={0} style={{ marginBottom: "15px" }}>
                    <h3>Leave Policy</h3>
                    <CKEditor
                      initData={getdata?.leave_policy_content || ""}
                      config={{
                        allowedContent: true,
                        extraPlugins: "colorbutton,font",
                        removeButtons: "",
                        colorButton_colors:
                          "000000,993300,333300,003300,003366,000080,333399,333333," +
                          "800000,FF6600,808000,008000,008080,0000FF,666699,808080," +
                          "FF0000,FF9900,99CC00,339966,33CCCC,3366FF,800080,969696," +
                          "FF00FF,FFCC00,FFFF00,00FF00,00FFFF,00CCFF,993366,C0C0C0," +
                          "FF99CC,FFCC99,FFFF99,CCFFCC,CCFFFF,99CCFF,CC99FF,FFFFFF," +
                          "123456,FFA500,4CAF50,9C27B0,2196F3,034766"
                      }}
                      onChange={(event) => {
                        const data = event.editor.getData();
                        setgetdata((prevData) => ({
                          ...prevData,
                          leave_policy_content: data
                        }));
                      }}
                    />
                    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mt: 1 }}>
                      <Typography variant="caption" color="text.secondary">
                        {lastUpdateMap["Leave Policy"]
                          ? `Last updated by ${lastUpdateMap["Leave Policy"].name} on ${lastUpdateMap["Leave Policy"].date_time}`
                          : ""}
                      </Typography>
                      <Button
                        onClick={() => setConfirmDialog({ open: true, key: "leave" })}
                        variant="contained"
                        size="small"
                        disabled={loading.leave}
                        startIcon={loading.leave && <CircularProgress size={16} color="inherit" />}
                      >
                        Publish Leave Policy
                      </Button>
                    </Stack>
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Stack spacing={0} style={{ marginBottom: "15px" }}>
                    <h3>OBT English Content</h3>
                    <CKEditor
                      initData={getdata?.obt_content}
                      config={{
                        allowedContent: true,
                        extraPlugins: "colorbutton,font",
                        removeButtons: "",
                        colorButton_colors:
                          "000000,993300,333300,003300,003366,000080,333399,333333," +
                          "800000,FF6600,808000,008000,008080,0000FF,666699,808080," +
                          "FF0000,FF9900,99CC00,339966,33CCCC,3366FF,800080,969696," +
                          "FF00FF,FFCC00,FFFF00,00FF00,00FFFF,00CCFF,993366,C0C0C0," +
                          "FF99CC,FFCC99,FFFF99,CCFFCC,CCFFFF,99CCFF,CC99FF,FFFFFF," +
                          "123456,FFA500,4CAF50,9C27B0,2196F3,034766"
                      }}
                      onChange={(event) => {
                        const data = event.editor.getData();
                        setgetdata((prevData) => ({
                          ...prevData,
                          obt_content: data
                        }));
                      }}
                    />
                    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mt: 1 }}>
                      <Typography variant="caption" color="text.secondary">
                        {lastUpdateMap["OBT English Content"]
                          ? `Last updated by ${lastUpdateMap["OBT English Content"].name} on ${lastUpdateMap["OBT English Content"].date_time}`
                          : ""}
                      </Typography>
                      <Button
                        onClick={() => saveField("obt")}
                        variant="contained"
                        size="small"
                        disabled={loading.obt}
                        startIcon={loading.obt && <CircularProgress size={16} color="inherit" />}
                      >
                        Update OBT English
                      </Button>
                    </Stack>
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Stack spacing={0} style={{ marginBottom: "15px" }}>
                    <h3>OBT Hindi Content</h3>
                    <CKEditor
                      initData={getdata?.obt_hindi_content}
                      config={{
                        allowedContent: true,
                        extraPlugins: "colorbutton,font",
                        removeButtons: "",
                        colorButton_colors:
                          "000000,993300,333300,003300,003366,000080,333399,333333," +
                          "800000,FF6600,808000,008000,008080,0000FF,666699,808080," +
                          "FF0000,FF9900,99CC00,339966,33CCCC,3366FF,800080,969696," +
                          "FF00FF,FFCC00,FFFF00,00FF00,00FFFF,00CCFF,993366,C0C0C0," +
                          "FF99CC,FFCC99,FFFF99,CCFFCC,CCFFFF,99CCFF,CC99FF,FFFFFF," +
                          "123456,FFA500,4CAF50,9C27B0,2196F3,034766"
                      }}
                      onChange={(event) => {
                        const data = event.editor.getData();
                        setgetdata((prevData) => ({
                          ...prevData,
                          obt_hindi_content: data
                        }));
                      }}
                    />
                    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mt: 1 }}>
                      <Typography variant="caption" color="text.secondary">
                        {lastUpdateMap["OBT Hindi Content"]
                          ? `Last updated by ${lastUpdateMap["OBT Hindi Content"].name} on ${lastUpdateMap["OBT Hindi Content"].date_time}`
                          : ""}
                      </Typography>
                      <Button
                        onClick={() => saveField("obtHindi")}
                        variant="contained"
                        size="small"
                        disabled={loading.obtHindi}
                        startIcon={loading.obtHindi && <CircularProgress size={16} color="inherit" />}
                      >
                        Update OBT Hindi
                      </Button>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            ) : (
              <Typography>Loading content...</Typography>
            )}
          </Stack>

          <Dialog open={confirmDialog.open} onClose={() => setConfirmDialog({ open: false, key: "" })}>
            {confirmDialog.key && (
              <>
                <DialogTitle>Require {labelMap[confirmDialog.key]} Acceptance</DialogTitle>
                <DialogContent>
                  <Typography>
                    Do you want to require all members to accept the updated {labelMap[confirmDialog.key]} before they can continue using the platform?
                  </Typography>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => handleForceAccept(0)} variant="contained" color="inherit">
                    No, Just Update
                  </Button>
                  <Button onClick={() => handleForceAccept(1)} variant="contained">
                    Yes, Require Acceptance
                  </Button>
                </DialogActions>
              </>
            )}
          </Dialog>

          <Dialog open={historyModal} onClose={toggleHistoryModal} maxWidth="md" fullWidth>
            <DialogTitle>Content History</DialogTitle>
            <DialogContent>
              {historyLoading ? (
                <Stack alignItems="center" justifyContent="center" sx={{ py: 5 }}>
                  <CircularProgress />
                </Stack>
              ) : historyData?.length > 0 ? (
                <TableContainer component={Paper} sx={{ mt: 1, maxHeight: 450 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 700 }}>No</TableCell>
                        <TableCell sx={{ fontWeight: 700 }}>Content</TableCell>
                        <TableCell sx={{ fontWeight: 700 }}>Updated By</TableCell>
                        <TableCell sx={{ fontWeight: 700 }}>Updated On</TableCell>
                        <TableCell sx={{ fontWeight: 700 }}>Force Re-accept</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {historyData.map((item, index) => (
                        <TableRow key={item.c_h_id}>
                          <TableCell>{historyData.length - index}</TableCell>
                          <TableCell>{item.column_name}</TableCell>
                          <TableCell>{item.name}</TableCell>
                          <TableCell>{item.date_time}</TableCell>
                          <TableCell>
                            {item.force_member_update == -1 ? (
                              "-"
                            ) : item.force_member_update == 1 ? (
                              <Chip
                                label="Yes"
                                size="small"
                                sx={{
                                  backgroundColor: "success.lighter",
                                  color: "success.main",
                                  fontWeight: 700,
                                  fontSize: "11px",
                                  borderRadius: "4px",
                                  height: "22px"
                                }}
                              />
                            ) : (
                              <Chip
                                label="No"
                                size="small"
                                variant="outlined"
                                sx={{
                                  color: "text.secondary",
                                  fontWeight: 600,
                                  fontSize: "11px",
                                  borderRadius: "4px",
                                  height: "22px"
                                }}
                              />
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Typography sx={{ py: 5, textAlign: "center" }}>No history found</Typography>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={toggleHistoryModal} variant="contained" color="inherit">
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </Card>
      </Container>
    </Page>
  );
};

export default DescriptionEdit;
